/**
 * =========================================================================================
 *     DOBLER DATA SOLUTIONS, LLC - PROPRIETARY AND CONFIDENTIAL
 * =========================================================================================
 * The source code contained herein is owned by Dobler Data Solutions, LLC. The source code
 * and all other copyrightable materials related thereto, including without limitation, all
 * text, logos, designs, graphics, other files, and other code, is protected under Title 17
 * of the United States Code. Any use, including any commercial use, distribution,
 * republication, or display of the source code or any other copyrightable materials related
 * thereto is strictly prohibited. Copyright © 2026 Dobler Data Solutions, LLC.
 * ALL RIGHTS RESERVED.
 * =========================================================================================
 *
 *     File Name       :   useIsAdmin.ts
 *     Description     :   Hook resolving whether the current MSAL caller carries the administrative
 *                         Entra app-role / group claim that gates the Remove Pharmacy surface.
 *                         Defense-in-depth only — the control-plane server is authoritative.
 *     Module          :   007-remove-pharmacy-parity
 *     Component Type  :   Hook
 *
 * -----------------------------------------------------------------------------------------
 *     CHANGE HISTORY
 * -----------------------------------------------------------------------------------------
 *     Version     Date            Author              Description
 * -----------------------------------------------------------------------------------------
 *     1.0         2026-06-23      Peter Dobler        Initial creation
 * -----------------------------------------------------------------------------------------
 *
 *     DEPENDENCIES
 * -----------------------------------------------------------------------------------------
 *     External        :   @azure/msal-browser
 *     Internal        :   msalConfig
 *
 *     EXPORTS
 * -----------------------------------------------------------------------------------------
 *     useIsAdmin
 *
 * =========================================================================================
 */

import { useCurrentUser } from "./UserProvider.js";

/**
 * Returns true when the current user holds the DB-backed Administrator role (the app-managed model).
 * Under DEV_AUTH_BYPASS the effective role honors the local dev role selector (see UserProvider),
 * so this reflects whatever role is being tested. Requires a {@link UserProvider} ancestor.
 */
export function useIsAdmin(): boolean {
  return useCurrentUser().isAdmin;
}
